// ── UndoToast — «Удалено · Отменить» с обратным отсчётом ──────────────────────
// Тёмная полоска над нижней панелью и мини-плеером (раньше стояла в 24 px от низа
// экрана и на телефоне закрывала нижнюю панель). Несколько — стопкой: stackIndex
// 0 — нижняя. Полоска снизу показывает, сколько осталось до настоящего удаления.

import { useEffect, useState } from "react";
import { t } from "../i18n";
import { SANS } from "../themes";
import { usePalette, Z } from "../ui/theme";

export function UndoToast({label,onUndo,duration=6000,stackIndex=0}){
  const C=usePalette();
  const [pct,setPct]=useState(100);
  useEffect(()=>{
    const start=Date.now();
    const id=setInterval(()=>{
      const left=Math.max(0,1-(Date.now()-start)/duration);
      setPct(left*100);
      if(left<=0)clearInterval(id);
    },50);
    return()=>clearInterval(id);
  },[duration]);
  // Шаг стопки — высота полоски (до двух строк) и зазор.
  const bottom=`calc(${16+stackIndex*72}px + var(--ac-nav-h, 0px) + var(--ac-mini-h, 0px) + env(safe-area-inset-bottom, 0px))`;
  // data-layout-layer: полоска временно лежит поверх страницы и уходит сама.
  return(
    <div role="status" data-layout-layer style={{
      position:"fixed",bottom,left:"50%",transform:"translateX(-50%)",
      background:"#2d3142",color:"#fff",
      padding:"6px 8px 6px 16px",borderRadius:12,
      boxShadow:"0 8px 32px rgba(0,0,0,.45),0 0 0 1px rgba(255,255,255,.06)",
      display:"flex",alignItems:"center",gap:12,
      zIndex:Z.toast,fontSize:14,lineHeight:1.35,fontFamily:SANS,boxSizing:"border-box",
      width:"max-content",minWidth:"min(280px, calc(100vw - 24px))",maxWidth:"min(520px, calc(100vw - 24px))",overflow:"hidden",
      animation:"undoSlideUp .22s cubic-bezier(.4,0,.2,1)",
    }}>
      <span title={label} style={{flex:1,minWidth:0,margin:"5px 0",display:"-webkit-box",WebkitBoxOrient:"vertical",WebkitLineClamp:2,overflow:"hidden",overflowWrap:"anywhere"}}>{label}</span>
      <button onClick={onUndo} style={{
        background:"transparent",border:`1px solid rgba(255,255,255,.28)`,
        color:"#fff",minHeight:36,padding:"0 14px",borderRadius:12,
        fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:SANS,
        flexShrink:0,whiteSpace:"nowrap",
      }}>{t("↶ Отменить")}</button>
      {/* Обратный отсчёт */}
      <div style={{position:"absolute",bottom:0,left:0,height:2,
        width:`${pct}%`,background:C.blue,transition:"width .05s linear"}}/>
      <style>{`@keyframes undoSlideUp{from{transform:translate(-50%,18px);opacity:0}to{transform:translate(-50%,0);opacity:1}}`}</style>
    </div>
  );
}
